import { useAppIntentLaunch } from './hooks/useAppIntentLaunch';
import { PrehookDialog } from './components/PrehookDialog';

/**
 * Host for useAppIntentLaunch. Renders the pre-hook modal and nothing else — it exists so
 * AppShell can mount the hook conditionally: only when an intent cookie is present does the
 * (heavier) useOpenAppModal hook, with its Apollo query and two dialog stores, get
 * instantiated. Calling the hook inline in AppShell would instantiate it for every session.
 *
 * It stays mounted for the rest of the session (AppShell's `hostAppIntentLauncher` is a
 * one-way snapshot), which is what lets the Get Started hand-off wait for the add-modal to
 * close long after the pre-hook itself is gone.
 */
export function AppIntentLauncher() {
  const { prehookApp, connect, dismiss } = useAppIntentLaunch();
  return <PrehookDialog appMeta={prehookApp} onConnect={connect} onDismiss={dismiss} />;
}
